import { targetingTypes } from '../../../LineItemDv360Create/fields'

export const getGeolocations = targeting => {
  return targeting
    .filter(item => item.type === targetingTypes.TARGETING_TYPE_GEO_REGION)
    .map(item => ({ ...item, label: item.display_name, value: item.targeting_option_id }))
}
